import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    color: '#78909C',
    fontSize: 10,
    fontWeight: 700,
    textTransform: 'uppercase',
    cursor: 'pointer',
    border: 0,
    backgroundColor: 'transparent',
    marginBottom: theme.spacing(2.85),
    '&:not(:disabled):hover': {
      '& > $icon': {
        transform: 'translateX(-3px)',
      },
    },
    '&:disabled': {
      cursor: 'not-allowed',
      opacity: 0.7,
    },
  },
  icon: {
    marginRight: theme.spacing(0.75),
    transition: 'transform 300ms',
    color: '#072D83',
  },
}));
